(() => {
  const KEY = '_tays_legal_acceptance_v1';
  const YES = 'accepted-20260922';
  const NO = 'pending-20260922';
  const roots = () => [...document.querySelectorAll('[data-tays-legal-root]')];
  let accepted = false, busy = true, revision = 0, queue = Promise.resolve();
  const rootUrl = window.Shopify?.routes?.root || '/';
  function refresh() {
    roots().forEach(root => {
      const box = root.querySelector('[data-tays-legal-checkbox]');
      if (box) { box.checked = accepted; box.disabled = busy; }
    });
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      button.disabled = busy || !accepted;
      button.setAttribute('aria-disabled', String(busy || !accepted));
    });
  }
  function persist(value) {
    queue = queue.catch(() => {}).then(async () => {
      const response = await fetch(`${rootUrl}cart/update.js`, {
        method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({attributes:{[KEY]:value}})
      });
      if (!response.ok) throw new Error('Onay kaydedilemedi');
      const cart = await response.json();
      if (cart.attributes?.[KEY] !== value) throw new Error('Onay doğrulanamadı');
    });
    return queue;
  }
  async function setAcceptance(value) {
    const current = ++revision;
    accepted = false; busy = true; refresh();
    roots().forEach(root => { root.querySelector('[data-tays-legal-error]').hidden = true; });
    try {
      await persist(value ? YES : NO);
      if (current === revision) accepted = value;
    } catch (_) {
      if (current === revision) roots().forEach(root => {
        const error = root.querySelector('[data-tays-legal-error]');
        error.textContent = 'Onay kaydedilemedi. Lütfen sayfayı yenileyip tekrar deneyin.';
        error.hidden = false;
      });
    } finally {
      if (current === revision) { busy = false; refresh(); }
    }
  }
  function init(root) {
    if (root.dataset.taysLegalReady) return;
    root.dataset.taysLegalReady = 'true';
    root.querySelector('[data-tays-legal-checkbox]').addEventListener('change', event => setAcceptance(event.target.checked));
    root.querySelectorAll('[data-tays-legal-document]').forEach(link => link.addEventListener('click', event => {
      const dialog = root.querySelector('[data-tays-legal-dialog]');
      if (!dialog?.showModal) return;
      event.preventDefault(); event.stopPropagation();
      root.querySelector('[data-tays-legal-dialog-title]').textContent = link.dataset.documentTitle;
      dialog.querySelectorAll('[data-tays-legal-content]').forEach(content => {
        content.hidden = content.dataset.taysLegalContent !== new URL(link.href).pathname;
      });
      dialog.showModal();
    }));
    root.querySelector('[data-tays-legal-close]').addEventListener('click', () => root.querySelector('dialog').close());
    root.querySelector('dialog').addEventListener('click', event => { if(event.target === event.currentTarget) event.currentTarget.close(); });
  }
  function scan() { roots().forEach(init); refresh(); }
  function start() {
    scan();
    // A restored cart attribute never counts as a new consent in this document.
    if (roots().length) setAcceptance(false);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => { scan(); setAcceptance(false); });
    }
    new MutationObserver(scan).observe(document.body, {childList:true,subtree:true});
  }
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' && (!accepted || busy)) event.preventDefault();
  }, true);
  window.addEventListener('pageshow', event => { if(event.persisted) setAcceptance(false); });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
